<template>

    <voffice-popup-box :trigger-id="triggerId"
        class="full-xxs"
        :apply-label="applyLabel"
        @closed="onClosed">

        <table class="guestbox">

            <tr v-for="(l,what) in sections"
                class="gb-row">

                <td class="gb-td label">
                    <label>{{getFieldLabel(what)}}</label>
                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        :disabled="!canDecr(what)"
                        @click="inc(what,-1)"
                        type="button">-</button>

                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        :disabled="!canInc(what)"
                        @click="inc(what,1)"
                        type="button">+</button>


                </td>
            </tr>

        </table>


    </voffice-popup-box>



</template>

<script>
    import vofficePopupBox from './PopupBox.vue';
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'voffice-guestbox',
    	components: {
    		vofficePopupBox
    	},
    	voMsgCodes: [
    		'pet.pl',
    		'adult.pl',
    		'child.pl',
    		'baby.pl'
    	],
    	props: {
    		maxValues: Object,
    		minValues: Object,
    		searchData: Object,
    		showDogCountInSearch: Boolean,
    		triggerId: String,
    		applyLabel: String,
    		childrenWelcome: Boolean,
    		petsWelcome: Boolean,
    		groups: Array,
    		beds: Number
    	},
    	computed: {
    		sections: function() {
    			var res = {
    				'adults': 'adult'
    			};
    			if (this.childrenWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    					'babys': 'baby'
    				});
    			}
    			if (this.petsWelcome) {
    				res.petsCount = 'pet';
    			}

    			return res;

    		}
    	},
    	methods: {
    		check4MaxBelegung: function() {
    			var additionalBaby;
    			var beds = this.beds;
    			var adults = this.searchData.adults;
    			var children = this.searchData.children;
    			var babys = this.searchData.babys;
    			var persons = parseInt(adults) + parseInt(children) + parseInt(babys);
    			var maxBabys = 99;
    			var maxAdults = 99;
    			var maxChildren = 99;
    			var additionalBabys;
    			//console.log('adults::', adults, 'children::', children, 'babys::', babys);

    			/*	console.log('beds::', beds);
    				console.log('adults::', adults);
    				console.log('children::', children); */

    			if (this.groups && this.groups.includes(41770)) {
    				//console.log('ist in Gruppe 41770');
    				if (adults >= beds) {
    					maxAdults = 0;
    					maxChildren = 0;
    					maxBabys = 0;
    				}
    				console.log('maxBabys::', maxBabys);
    				if (parseInt(adults) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen wurde überschritten.';
    				} else if (parseInt(children) + parseInt(adults) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen wurde überschritten.';
    				} else if (parseInt(children) + parseInt(adults) + parseInt(babys) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen wurde überschritten.';
    				} else {
    					this.$parent.personsWarning = undefined;
    				}
    			} else if (this.groups && this.groups.includes(41771)) {
    				//console.log('ist in Gruppe 41771');
    				additionalBabys = 1;
    				if (persons > beds) {
    					maxAdults = 0;
    					maxChildren = 0;
    					maxBabys = 0;
    				}
    				if (parseInt(adults) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen und einem Baby wurde überschritten.';
    				} else if (parseInt(children) + parseInt(adults) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen und einem Baby wurde überschritten.';
    				} else if ((parseInt(children) + parseInt(adults)) + (parseInt(babys) - 1) > parseInt(beds)) {
    					this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen und einem Baby wurde überschritten.';
    				} else {
    					this.$parent.personsWarning = undefined;
    				}

    			} else if (parseInt(adults) > parseInt(beds)) {
    				this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen wurde überschritten.';
    			} else if (parseInt(children) + parseInt(adults) > parseInt(beds)) {
    				this.$parent.personsWarning = 'Die maximale Belegung von ' + beds + ' Personen wurde überschritten.';
    			} else {
    				this.$parent.personsWarning = undefined;
    			}
    		},
    		onClosed: function() {
    			this.$emit('closed');
    		},

    		getFieldLabel: function(what) {
    			var amount = this.searchData[what] || 0;
    			return amount + ' ' + this.voMsgPl(this.sections[what] + '.pl', amount);
    		},
    		inc: function(what, step) {
    			this.searchData[what] = ((this.searchData[what] || 0) - 0) + step;
    			if (what == 'petsCount') {
    				this.searchData.pets = this.searchData[what] > 0;
    			}

    		},
    		canInc: function(what) {
    			var max = this.check4MaxBelegung();
    			var amount = ((this.searchData[what] || 0) - 0);

    			if (max != undefined && amount >= max) {
    				return false;
    			}
    			return true;
    		},
    		canDecr: function(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var min = this.minValues && this.minValues[what];
    			if (min == undefined) {
    				min = what == 'adults' ? 1 : 0
    			}

    			if (min != undefined && amount <= min) {
    				return false;
    			}
    			return true;
    		},

    	}

    };
</script>

<style scoped>
    .guestbox {
    	margin: 0 auto;
    	line-height: 46px;
    	text-align: left;
    	font-size: 15px;
    	color: #676767;
    }


    .gb-td {
    	padding: 8px 12px;
    }

    .btn {
    	width: 48px;
    	height: 48px;
    	line-height: 1;
    	border-radius: 50%;
    	font-size: 30px;
    	padding: 4px;
    }

    .label {
    	white-space: nowrap;
    }

    @media (max-width:768px) {}
</style>